// Polyfills
import "babel-polyfill";
import "vue-svgicon/dist/polyfill";

// Vue
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// Vue Filters
import Vue2Filters from "vue2-filters";

// Validation
import VeeValidate from "vee-validate";

// ---------------------------------------------------------------
// Dates (DayJS)
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
// ---------------------------------------------------------------

import SvgIcon from "vue-svgicon";
import PortalVue from "portal-vue";

// azure
import * as msal from "@azure/msal-browser";

// iCal
import ICS from "vue-ics";
const icsOptions = {};
Vue.use(ICS, icsOptions);

// performance
Vue.config.performance = true;

Vue.use(Vue2Filters);
Vue.use(VeeValidate, { fieldsBagName: "formFields" });

dayjs.extend(relativeTime);
Vue.prototype.$dayjs = dayjs;

Vue.use(SvgIcon, {
  tagName: "icon",
});
Vue.use(PortalVue);

Vue.config.productionTip = false;

/**
 * Environment variables
 */

// disable admin
Vue.prototype.$adminDisabled =
  process.env.VUE_APP_DISABLE_ADMIN &&
  process.env.VUE_APP_DISABLE_ADMIN != "false";

// disable ms login
// if there is no msal id, it should be disabled
if (!process.env.VUE_APP_MSAL_CLIENT) {
  Vue.prototype.$msLoginDisabled = true;
} else {
  Vue.prototype.$msLoginDisabled =
    process.env.VUE_APP_DISABLE_MS_LOGIN &&
    process.env.VUE_APP_DISABLE_MS_LOGIN != "false";
}

// disable email login
Vue.prototype.$emailLoginDisabled =
  process.env.VUE_APP_DISABLE_EMAIL_LOGIN &&
  process.env.VUE_APP_DISABLE_EMAIL_LOGIN != "false";

// disable header orange bar login
Vue.prototype.$infobarDisabled =
  process.env.VUE_APP_DISABLE_INFOBAR &&
  process.env.VUE_APP_DISABLE_INFOBAR != "false";

// disable app download
Vue.prototype.$appCtaDisabled =
process.env.VUE_APP_DISABLE_APP_DOWNLOAD &&
process.env.VUE_APP_DISABLE_APP_DOWNLOAD != "false";

// app download links
Vue.prototype.$iosDownloadLink = process.env.VUE_APP_IOS_DOWNLOAD;
Vue.prototype.$androidDownloadLink = process.env.VUE_APP_ANDROID_DOWNLOAD;

// msal
const msalConfig = {
  auth: {
    clientId: process.env.VUE_APP_MSAL_CLIENT,
  },
};
const msalInstance = new msal.PublicClientApplication(msalConfig);

Vue.prototype.$msal = msalInstance;

Vue.filter("titleCase", (val) =>
  val
    .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
    .map((x) => x.charAt(0).toUpperCase() + x.slice(1))
    .join(" ")
);

Vue.filter("capitalize", (value) => {
  if (!value) return "";
  const newVal = value.toString();
  return newVal.charAt(0).toUpperCase() + newVal.slice(1);
});

Vue.filter("extension", (value) => {
  const re = /(?:\.([^.]+))?$/;
  if (!value) return "";
  const returnVal = re.exec(value)[1];
  return returnVal;
});

Vue.filter(
  "truncate",
  (text, stop, clamp) =>
    text.slice(0, stop) + (stop < text.length ? clamp || "..." : "")
);

Vue.directive("scroll", {
  inserted(el, binding) {
    const f = (evt) => {
      if (binding.value(evt, el)) {
        window.removeEventListener("scroll", f);
      }
    };
    window.addEventListener("scroll", f);
  },
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

function removeAppLoading() {
  setTimeout(() => {
    const $appLoading = document.querySelectorAll(".app-loading")[0];

    if ($appLoading.remove) {
      $appLoading.remove();
    } else {
      $appLoading.parentNode.removeChild($appLoading);
    }
  }, 300);
}

if (window.addEventListener) {
  window.addEventListener("load", removeAppLoading, false);
} else if (window.attachEvent) {
  window.attachEvent("onload", removeAppLoading);
} else if (window.onload) {
  window.onload = removeAppLoading;
}
